const mytext = `感謝，維明化工訂購BUNDESMANN(DAIEI) / 遠東新世紀簽訂儀器定保合約`;
export default mytext ;